var _path, _path2, _rect, _g, _rect2, _rect3, _rect4, _rect5, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgServiceEstateStep5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 247,
    viewBox: "0 0 292 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121 43.8437C121 37.7686 125.925 32.8438 132 32.8438H272V235.844C272 241.919 267.075 246.844 261 246.844H121V43.8437Z",
    fill: "#FFCF85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263 32.8438H281C287.075 32.8438 292 37.7686 292 43.8438V112.844C292 118.919 287.075 123.844 281 123.844H263V32.8438Z",
    fill: "#FFCF85"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 67.8438,
    width: 99,
    height: 27,
    fill: "#FFF2DE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_69_178)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166.495,
    height: 220.767,
    rx: 4,
    fill: "#F4F4F4"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4355,
    y: 106.256,
    width: 108.544,
    height: 5.5,
    rx: 2.75,
    fill: "#DFDFDF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4355,
    y: 82.8438,
    width: 108.544,
    height: 5.5,
    rx: 2.75,
    fill: "#DFDFDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4355,
    y: 129.256,
    width: 108.544,
    height: 5.5,
    rx: 2.75,
    fill: "#DFDFDF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 152.256,
    width: 78,
    height: 5.5,
    rx: 2.75,
    fill: "#DFDFDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7617 49.7109C36.752 52.582 38.2363 55.6582 41.2148 56.8984L39.8672 58.8516C37.7773 57.9629 36.332 56.1953 35.5312 54.0469C34.7305 56.3809 33.2559 58.334 31.1562 59.3008L29.7305 57.3281C32.6797 56.0098 34.2031 52.7188 34.2031 49.7109V48.6172H30.4336V46.5859H40.4727V48.6172H36.7617V49.7109ZM42.2305 62.6406V44.8672H44.75V62.6406H42.2305ZM51.5469 54.9844V56.8789H58.9492V54.9844H61.4102V62.4453H49.1055V54.9844H51.5469ZM47.1523 53.8125V51.8203H58.5977C58.9395 50.1016 58.9883 48.7734 59.0078 47.582H49.1445V45.5898H61.4883V47.0156C61.498 48.3633 61.498 49.7988 61.0684 51.8203H63.4219V53.8125H47.1523ZM51.5469 60.4336H58.9492V58.7734H51.5469V60.4336ZM79.418 44.8672V55.2773H76.9375V53.0117H73.6172V54.3008H65.1797V46.1758H73.6172V47.4648H76.9375V44.8672H79.418ZM67.2305 59.2031C67.2305 57.0156 69.5547 55.7363 73.3438 55.7461C77.1426 55.7363 79.4668 57.0156 79.4766 59.2031C79.4668 61.4004 77.1426 62.6504 73.3438 62.6406C69.5547 62.6504 67.2305 61.4004 67.2305 59.2031ZM67.6602 52.3281H71.1758V48.1484H67.6602V52.3281ZM69.7109 59.2031C69.7109 60.2188 70.9902 60.7461 73.3438 60.7461C75.707 60.7461 76.9863 60.2188 76.9961 59.2031C76.9863 58.1484 75.707 57.6406 73.3438 57.6406C70.9902 57.6406 69.7109 58.1484 69.7109 59.2031ZM73.6172 51H76.9375V49.4375H73.6172V51ZM90.2578 45.7852V51.3125H84.8867V53.0996C87.5234 53.0801 89.1055 52.9922 90.9023 52.6797L91.1367 54.6719C89.0566 55.0527 87.1914 55.1211 83.7539 55.1211H82.4258V49.4375H87.7773V47.7969H82.3867V45.7852H90.2578ZM84.5156 59.3594C84.5156 57.2305 86.8398 55.9707 90.668 55.9805C94.4668 55.9707 96.7812 57.2305 96.8008 59.3594C96.7812 61.4883 94.4668 62.709 90.668 62.6992C86.8398 62.709 84.5156 61.4883 84.5156 59.3594ZM87.0547 59.3594C87.0352 60.3359 88.2754 60.8047 90.668 60.8047C93.0312 60.8047 94.3105 60.3359 94.3203 59.3594C94.3105 58.3535 93.0312 57.875 90.668 57.875C88.2754 57.875 87.0352 58.3535 87.0547 59.3594ZM91.293 52.9141V50.9219H94.2031V49.2617H91.293V47.25H94.2031V44.8867H96.7031V55.6875H94.2031V52.9141H91.293ZM119.887 58.5195V60.5117H103.617V58.5195H110.414V54.4961H112.895V58.5195H119.887ZM104.008 52.9922C108.031 52.3672 110.297 49.6621 110.316 47.1523V45.8828H112.973V47.1523C112.963 49.6914 115.258 52.3672 119.32 52.9922L118.266 55.0625C115.141 54.4961 112.816 52.8262 111.645 50.6094C110.482 52.8164 108.168 54.5059 105.062 55.0625L104.008 52.9922ZM130.219 51.1562V53.3438H137.113V55.3359H120.902V53.3438H127.758V51.1562H130.219ZM121.742 50.2773C125.668 49.7793 127.709 47.748 127.719 45.7461V45.1602H130.258V45.7461C130.248 47.8262 132.24 49.7793 136.254 50.2773L135.297 52.2109C132.289 51.7617 130.082 50.502 128.959 48.7246C127.826 50.4922 125.619 51.7715 122.621 52.2109L121.742 50.2773ZM122.758 59.4961C122.758 57.4746 125.092 56.3223 128.988 56.3125C132.855 56.3223 135.16 57.4746 135.18 59.4961C135.16 61.5176 132.855 62.6504 128.988 62.6406C125.092 62.6504 122.758 61.5176 122.758 59.4961ZM125.297 59.4961C125.287 60.3652 126.498 60.7852 128.988 60.7852C131.42 60.7852 132.67 60.3652 132.68 59.4961C132.67 58.6074 131.42 58.2168 128.988 58.207C126.498 58.2168 125.287 58.6074 125.297 59.4961Z",
    fill: "#374969"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_69_178",
    x: 0,
    y: 0,
    width: 174.495,
    height: 228.766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_69_178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_69_178",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgServiceEstateStep5);
export default __webpack_public_path__ + "static/media/ImgServiceEstateStep5.83d9c7cdff32708bca8f4f0d3197cc65.svg";
export { ForwardRef as ReactComponent };